module.exports = __webpack_public_path__ + "img/uitvoering.f1159552.svg";